module.exports = __webpack_public_path__ + "img/당산 피자.00450a79.png";